const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getWalletBalance = async (walletId) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/eci/apis/v4/wallets/${walletId}/get_balance`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      throw new Error("Failed to fetch wallet balance");
    }

    const data = await response.json();
    return data.msg;
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
    throw error;
  }
};
